import { useForm } from "@mantine/form";
import { Button, TextInput } from "@monolith-forensics/monolith-ui";
import { M365SaveClientCredentialsData } from "../M365.types";
import { useState } from "react";
import { M365Query } from "../M365.query";
import { IntegrationScope } from "../../integrations.types";

export const M36SaveClientCredentialsForm: React.FC<{
  defaultValues?: M365SaveClientCredentialsData;
  onSubmit?: (values: M365SaveClientCredentialsData) => void;
  onSaved?: () => void;
  onCancel?: () => void;
}> = ({ defaultValues, onSubmit, onSaved, onCancel }) => {
  const [saving, setSaving] = useState(false);
  const { mutate: saveClientCredentials } =
    M365Query.useSaveClientCredentials();

  const form = useForm<Partial<M365SaveClientCredentialsData>>({
    initialValues: {
      client_id: defaultValues?.client_id,
      client_secret: defaultValues?.client_secret,
      tenant_id: defaultValues?.tenant_id,
      scope: defaultValues?.scope || IntegrationScope.TENANT,
    },
    validate: {
      client_id: (value) => (!!value ? null : "Client ID is required"),
      client_secret: (value) => (!!value ? null : "Client Secret is required"),
      tenant_id: (value) => (!!value ? null : "Tenant ID is required"),
    },
  });

  const handleSave = () => {
    const errors = form.validate();

    if (errors.hasErrors) {
      return;
    }

    setSaving(true);

    const formData = form.values as M365SaveClientCredentialsData;

    onSubmit?.(formData);

    saveClientCredentials(formData, {
      onSuccess: () => {
        M365Query.resetQuery();
        setSaving(false);
        onSaved?.();
      },
      onError: () => {
        setSaving(false);
      },
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}
    >
      <TextInput label="Client ID" {...form.getInputProps("client_id")} />
      <TextInput
        label="Client Secret"
        {...form.getInputProps("client_secret")}
      />
      <TextInput label="Tenant ID" {...form.getInputProps("tenant_id")} />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 10,
          justifyContent: "flex-end",
          marginTop: 10,
        }}
      >
        <Button variant="subtle" onClick={onCancel} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          loading={saving}
        >
          Save
        </Button>
      </div>
    </div>
  );
};
